import axios from "axios";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

const FreeConsultation = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        honeypot: '',
        timestamp: Date.now()
    });

    // Load cached data from localStorage
    useEffect(() => {
        const cachedFormData = JSON.parse(localStorage.getItem('consultationFormData'));
        if (cachedFormData) {
            setFormData(cachedFormData);
        }
    }, []);

    // Save data to localStorage when formData changes
    useEffect(() => {
        localStorage.setItem('consultationFormData', JSON.stringify(formData));
    }, [formData]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.honeypot) {
            toast.error('Please send message later.');
            return;
        }
        const submissionTime = Date.now();
        const timeDiff = submissionTime - formData.timestamp;

        if (timeDiff < 3000) {
            toast.error('Please send message later.');
            return;
        }
        try {
            const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
            const Url = process.env.REACT_APP_API_FREE_CONSULTATION_MESSAGE_STORE;
            const response = await axios.post(`${apiBaseUrl}${Url}`, formData);

            if (response.status === 200) {
                toast.success('Message sent successfully!');
                // Clear cached data after successful submission
                localStorage.removeItem('consultationFormData');
                setFormData({ name: '', phone: '', honeypot: '', timestamp: Date.now() });
            } else {
                toast.error('Something went wrong. Try again.');
            }
        } catch (error) {
            toast.error('Failed to send message.');
        }
    };

    return (
        <section className="slider-area fix pt-10 pb-10">
            <div className="container px-1">
                <div className="p-4 rounded-4" style={{ backgroundColor: '#1C4ABE' }}>
                    <form onSubmit={handleSubmit}>
                        <div className="apply-header">
                            <h3 className="title text-white fw-bold">Get Free Consultaion </h3>
                        </div>
                        <div className="row pt-4 g-3">
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <div className="input-group">
                                        <i className="input-group-text far fa-user"></i>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            placeholder="Your Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <div className="input-group">
                                        <i className="input-group-text far fa-phone"></i>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="phone"
                                            placeholder="Your Phone Number"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* Honeypot field - hidden from the user */}
                            <input
                                type="hidden"
                                name="honeypot"
                                value={formData.honeypot}
                                onChange={handleChange}
                            />
                            <div className="text-end">
                                <button type="submit" className="btn btn-primary">Submit <i className="fas fa-arrow-circle-right"></i></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
}

export default FreeConsultation;
